// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"bfdbf68943c63e01bf03","655":"0b3145efc9521b14d9f5"}[chunkId] + ".js";
};